
import { Reducer } from 'redux';
import { mergeReducers } from 'app/infrastructure/redux/merge-reducers';
import { SelectionReportInstanceState, SelectionReportState } from './types-store';
import { aggregationReducer, aggregationReducers, INITIAL_STATE as aggregateFieldState } from './containers/aggregation/reducers';
import { distributionReducer, distributionReducers, INITIAL_STATE as distributionFieldState } from './containers/distribution/reducers';
import { groupByReducer, groupByReducers, INITIAL_STATE as groupByFieldState } from './containers/group-by/reducers';
import { targetReducer, INITIAL_STATE as targetFieldState, targetReducers } from './containers/target/reducers';
import { chartReducer, chartReducers, INITIAL_STATE as chartState } from './containers/chart/reducers';
import { ACTION, AddInstance, ClearInstance } from './action-types';

export const INITIAL_STATE: SelectionReportState = {
  instances: {},
  texts: undefined
};

export const INITIAL_INSTANCE_STATE: SelectionReportInstanceState = {
  aggregateFieldState,
  distributionFieldState,
  groupByFieldState,
  targetFieldState,
  chartState
};

const instanceReducer: Reducer<SelectionReportInstanceState> = mergeReducers({
  aggregateFieldState: aggregationReducer,
  distributionFieldState: distributionReducer,
  groupByFieldState: groupByReducer,
  targetFieldState: targetReducer,
  chartState: chartReducer
});

const topLevelReducers: {
  [indexer: string]: Reducer<SelectionReportState>;
} = {
  [ACTION.ADD_INSTANCE]: (state: SelectionReportState, action: AddInstance): SelectionReportState => {
    return {
      ...state,
      instances: {
        ...state.instances,
        [action.instanceKey]: {
          ...INITIAL_INSTANCE_STATE
        }
      }
    };
  },
  [ACTION.CLEAR_INSTANCE]: (state: SelectionReportState, action: ClearInstance): SelectionReportState => {
    return {
      ...state,
      instances: Object.keys(state.instances).filter(i => i !== action.instanceKey).reduce(
        (aggr, i) => {
          aggr[i] = state.instances[i];
          return aggr;
        }, {})
    };
  }
};

function isInstanceReducer(actionType: string) {
  return aggregationReducers[actionType] || 
         chartReducers[actionType] || 
         distributionReducers[actionType] || 
         groupByReducers[actionType] || 
         targetReducers[actionType];
}

export const reducer: Reducer<SelectionReportState> = (state: SelectionReportState = INITIAL_STATE, action: any) => {
  if (topLevelReducers[action.type]) {
    return topLevelReducers[action.type](state, action);
  }
  else if (isInstanceReducer(action.type) && action.instanceKey) {
    return {
      ...state,
      instances: {
        ...state?.instances,
        [action.instanceKey]: {
          ...instanceReducer(state?.instances[action.instanceKey] ?? INITIAL_INSTANCE_STATE, action)
        }
      }
    };
  }
  
  return state;
};
